export default function(data) {
  var self = this;
  /*------------------------------------------------GRADING POLICY--------------------------------------------------*/
  self.grading_policy_entries = ko.observableArray();
  self.oldPolicyWeight = ko.observable();

  self.grading_policy_mapping = {
    update: function(options) {
      var vm = ko.mapping.fromJS(_.extend(options.data, {
        saved: ko.observable(true),
        editing: ko.observable(options.data.editing || false),
        select_from_preset: ko.observable(options.data.select_from_preset || false), color: ko.computed(function () {
          var policy_index = self.grading_policy_entries.indexOf(vm);
          var color_index = policy_index % Kadenze.COLORS.length;
          return Kadenze.COLORS[color_index];
        })
      }));
      vm.client_errors = null;
      vm.isValid = ko.computed(function () {
        vm.client_errors = ko.validation.group(vm, { deep: true });
        return (vm.client_errors().length == 0);
      });
      vm.editing.subscribe(function (value) {
        vm.saved(false);
        self.saveGradingPolicy(vm);
      });
      vm.selected_preset = ko.computed({
        read: function () {
          return vm.grading_policy_preset_id();
        },
        write: function (id) {
          if (!isNaN(parseInt(id))) {
            if (id == -1) {
              vm.select_from_preset(false);
              vm.grading_policy_preset_id(null);
            } else {
              var selected = _.find(self.course().grading_policy_presets(), function (preset) {
                return preset.id() == id;
              });
              vm.grading_policy_preset_id(selected.id());
              vm.name(selected.name());
              vm.editing(false);
            }
          }
        }
      });
      vm.otherPolicyNames = ko.computed(function () {
        return _.map(self.grading_policy_entries(), function (entry) {
          return entry.name();
        });
      });
      vm.name.extend({ required: true, maxLength: 30, isUnique: {
        params: {
          array: vm.otherPolicyNames,
          predicate: function (opt, selectedVal) {
            return opt && (opt.toLowerCase().trim() === selectedVal.toLowerCase().trim());
          }
        },
        onlyIf: function() { return !vm.saved(); },
        message: 'This policy name is already taken'
      } });
      return vm;
    }
  };

  self.saveGradingPolicy = function (policy) {
    if (policy.isValid() && !policy.editing()) {
      var data = {};
      data.grading_policy_entry = ko.mapping.toJS(policy);
      var request = new Kadenze.AjaxRequest({
        type: policy.id() ? 'PATCH' : 'POST',
        url: policy.id() ? Kadenze.Routes.course_grading_policy_entry_path(self.course().id(), policy.id()) : Kadenze.Routes.course_grading_policy_entries_path(self.course().id()),
        data: data,
        timeout: 60000
      });

      request.done(function(response, status, xhr) {
        var entry = ko.mapping.fromJSON(response.entry);
        policy.id(entry.id());
        policy.saved(true);
      });

      request.fail(function(xhr, status, msg) {
        policy.editing(true);
        new Kadenze.Notice.error({message: xhr.responseJSON.errors});
      });
    } else {
      policy.client_errors.showAllMessages(true);
    }
  };
  self.onEnterCustomPolicy = function (item, event) {
    if (event.keyCode === 13) {
      item.editing(false);
    }
    return true;
  };
  self.onEnterWeight = function (item, event) {
    if (event.keyCode === 13) {
      event.stopPropagation();
    } else {
      return true;
    }
  };
  self.addGradingPolicy = function (item, event) {
    var policy = {id: null, course_id: self.course().id(), name: null, weight: 0, color: '',
      grading_policy_preset_id: null, required: false, editing: true, select_from_preset: true};
    var mapped_policy = ko.mapping.fromJS(policy, self.grading_policy_mapping);
    self.grading_policy_entries.push(mapped_policy);
    event.stopPropagation();
  };
  self.editGradingPolicy = function (item, event) {
    if (!item.required()) {
      item.editing(true);
    }
    event.stopPropagation();
  };
  self.deleteGradingPolicy = function (item, event) {
    if (item.required()) {
      new Kadenze.Notice.error({message: item.name() + ' policy is required by the admins and cannot be deleted.'});
    } else if (item.id()) {
      var request = new Kadenze.AjaxRequest({
        type: 'DELETE',
        url: Kadenze.Routes.course_grading_policy_entry_path(self.course().id(), item.id()),
        data: null,
        timeout: 60000
      });

      request.done(function(response, status, xhr) {
        self.grading_policy_entries.remove(item);
        new Kadenze.Notice.success({});
      });

      request.fail(function(xhr, status, msg) {
        new Kadenze.Notice.error({message: xhr.responseJSON.errors});
      });
    } else {
      self.grading_policy_entries.remove(item);
    }
  };
  self.isPolicyPresetUsed = function (item, event) {
    return (_.findIndex(self.grading_policy_entries(), function (entry) { return entry.grading_policy_preset_id() == item.id(); }) > -1);
  };
  self.stopPropagation = function (item, event) {
    event.stopPropagation();
  };
  self.setupGradingPolicyFocusHack = function () {
    //This is used in place of a foucusout/blur event for select pickers
    $(window).click(function(e) {
      _.each(self.grading_policy_entries(), function (entry) {
        if (entry.editing() && !isNaN(parseInt(entry.grading_policy_preset_id()))) {
          entry.editing(false);
        }
      });
    });
  };
  self.totalPolicyWeight = function() {
    if (self.grading_policy_entries) {
      var total = _.reduce(self.grading_policy_entries(), function(memo, entry){ return memo + entry.weight(); }, 0);
    }
    return total || 0;
  };
  self.showPolicyWeightWarning = function () {
    if (self.oldPolicyWeight() <= 100 && self.totalPolicyWeight() > 100) {
      new Kadenze.Notice.attention($.extend({}, self.defaultNoticeOptions, {message: 'Your grading policy currently allows a maximum grade of over 100%.' }));
    }
    self.oldPolicyWeight(self.totalPolicyWeight());
  };

  self.initGradingPolicyBreakdownChart = function() {
    var getStackedBarChartDatasets = function () {
      var unsortedArr = _.map(self.grading_policy_entries(), function(entry) {
        var datasetObj = {
          label: entry.name(),
          data: [parseInt(entry.weight())],
          backgroundColor: entry.color(),
          borderColor: '#ffffff',
          borderWidth: 1
        };
        return datasetObj;
      });
      return _.sortBy(unsortedArr, function(obj){return obj.data[0];}).reverse();
    };

      // STACKED BAR CHART ----------------------------------------------------------- //
    var stackedBarChartElement = document.getElementById('chartjs-stacked-bar');
    if (stackedBarChartElement) {
      var datasetsArr = getStackedBarChartDatasets();
      var stackedBar = new Chart(stackedBarChartElement, {
        type: 'bar',
        data: {
          labels: [],
          datasets: datasetsArr
        },
        options: {
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              stacked: true,
              ticks: {
                beginAtZero:true
              }
            }],
            xAxes: [{
              stacked: true,
              display: false
            }]
          },
          tooltips: {
            titleSpacing: 0,
            xPadding: 15,
            callbacks: {
              label: function(tooltipItem, data){
                return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
              }
            }
          }
        }
      });
      ko.computed(function() {
        ko.mapping.toJSON(self.grading_policy_entries());
        var datasetsArr = getStackedBarChartDatasets();
        stackedBar.data.datasets = datasetsArr;
        stackedBar.update(0);
      });
    }
  };

  self.dataForSaving = function(opts) {
    var obj = ko.mapping.toJS(self.course);

    obj.grading_policy_entries_attributes = ko.mapping.toJS(self.grading_policy_entries());

    delete obj.grading_policy_entries;

    return $.extend(true, {}, {'course': obj}, opts);
  };


  self.save = function() {
    var errors = ko.validation.group(self.course)();

    if (errors.length > 0){
      new Kadenze.Notice.error({message: errors[0]});
      return false;
    }

    // Build our object
    var data = self.dataForSaving();
    var type = 'POST';
    var url = Kadenze.Routes.courses_path();
    if (self.course().id()) {
      type = 'PUT';
      url = Kadenze.Routes.course_path(self.course().id());
    }

    return $.ajax({
      type: type,
      url: url,
      data: data,
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    }).success(function(data) {
      // Kadenze.UIUtil.showNotice($('#main-pjax-container'), data, 2000);
      var courseData = JSON.parse(data.course);

      new Kadenze.Notice.success(
        $.extend(
          {},
          self.defaultNoticeOptions,
          {
            message: I18n.t('notices.save.success', { saved: I18n.t('dict.grading_policy') })
          }
        )
      );
      self.showPolicyWeightWarning();
    }).error(function(response) {
      console.warn('error saving grading policies');
      console.debug(response);

      new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: response.responseJSON.errors }));
    });
  };

  const __construct = function(that) {
    console.log('constructor called for GradeBookGradingPoliciesViewModel');
    
    const mapping = {
      'create': function({ data }) {
        return ko.mapping.fromJS(data, {
          grading_policy_entries: self.grading_policy_mapping
        });
      }
    };

    that.course = ko.observable(ko.mapping.fromJSON(data, mapping));

    that.grading_policy_entries(that.course().grading_policy_entries());

    //Hack to make edit-in-place UX work with select pickers
    self.setupGradingPolicyFocusHack();
    self.initGradingPolicyBreakdownChart();
    self.oldPolicyWeight(self.totalPolicyWeight());
  }(this);
}
